import $ from 'jquery';
import * as CONST from '../utils/constants';

class Accordion {
    constructor() {
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        // Title click
        $(document).on('click', '.accordion-title', e => {
            const accordion = $(e.currentTarget);

            // Toggle active class
            $(accordion).toggleClass('accordion-title--active');

            // Toggle aria-expanded
            if ($(accordion).attr('aria-expanded') === 'false') {
                $(accordion).attr('aria-expanded', 'true');
            }
            else {
                $(accordion).attr('aria-expanded', 'false');
            }

            // Toggle content visibility
            $(accordion).next('.accordion-content').stop().slideToggle();
        });
    }
}

export default Accordion;